import * as THREE from 'three'
import Experience from '../Experience.js'
import { shareLink } from '../Utils/share.js'

// Fin de visite : au-dessus du parcours (outro), un panneau propose
// l'appel à l'action (réservation), de revoir le parcours ou de le
// partager. Contenu : presentation.json (finale).
export default class Finale {
    constructor() {
        this.experience = new Experience()
        this.root = document.querySelector('.finale')
        this.data = this.experience.resources.items.presentation?.finale ?? {}
        this.range = this.experience.config.course.finale ?? { start: 0.965, end: 0.985 }
        this.opacity = -1

        this.render()
        this.bindEvents()
    }

    render() {
        if (!this.root) return

        const set = (selector, value) => {
            const element = this.root.querySelector(selector)
            if (element && value) element.textContent = value
        }

        set('.finale__eyebrow', this.data.eyebrow)
        set('.finale__title', this.data.title)
        set('.finale__text', this.data.text)

        const cta = this.root.querySelector('.finale__cta')
        if (cta) {
            if (this.data.cta?.href) {
                cta.href = this.data.cta.href
                cta.querySelector('.finale__cta-label').textContent = this.data.cta.label ?? cta.textContent
                if (/^https?:/.test(this.data.cta.href)) {
                    cta.target = '_blank'
                    cta.rel = 'noopener noreferrer'
                }
            } else {
                cta.hidden = true
            }
        }
    }

    bindEvents() {
        this.onClick = async (event) => {
            const action = event.target.closest('[data-action]')?.dataset.action
            if (action === 'replay') {
                this.experience.timeline?.restartTour()
            } else if (action === 'share') {
                const url = `${window.location.origin}${window.location.pathname}`
                const result = await shareLink({
                    title: document.title,
                    text: 'Découvrez le Golf des Hautes Terres en 3D',
                    url
                })
                if (result === 'copied') this.experience.modeToggle?.showHint('Lien du parcours copié')
            }
        }
        this.root?.addEventListener('click', this.onClick)
    }

    update(progress) {
        if (!this.root) return

        const timeline = this.experience.timeline
        const active = timeline?.intro?.isDone && timeline.viewMode === 'guided'
        const opacity = active ? THREE.MathUtils.smoothstep(progress, this.range.start, this.range.end) : 0

        if (Math.abs(opacity - this.opacity) < 0.001) return
        this.opacity = opacity

        this.root.style.opacity = opacity.toFixed(3)
        this.root.style.setProperty('--finale-shift', `${(1 - opacity) * 16}px`)
        this.root.classList.toggle('is-visible', opacity > 0.6)
        this.root.setAttribute('aria-hidden', String(opacity <= 0.6))
        document.body.classList.toggle('finale-active', opacity > 0.6)
    }

    destroy() {
        this.root?.removeEventListener('click', this.onClick)
        this.experience = null
    }
}
